import arrayUtilities from "./arrayUtilities";
import stringUtilities from "./stringUtilities";

export default {
    isSketchObjectLimitCurrentlyPrinting(limitId, sketchLimits, printingSketchLimitIndex) {
        if (stringUtilities.isNullOrEmpty(limitId) || arrayUtilities.isNullOrEmpty(sketchLimits)) {
            return true;
        }

        const limitIndex = sketchLimits.findIndex(x => x.id === limitId);

        return limitIndex === -1 || limitIndex === printingSketchLimitIndex;
    },

    getLimitName(limits, index) {
        return limits[index]?.name || `Limit ${index + 1}`;
    }
}